import BootDatePicker from "components/common/custom/forms/BootDatePicker";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import FalconComponentCard from "components/common/FalconComponentCard";
import MultiSelect from "components/common/MultiSelect";
import React, { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";

const DoseMedicalHistory = ({ setValue, watch, control }) => {
  const { doseList, stepFormData, viewModal, selectedService } = useSelector(
    (state) => state.preauthorization
  );
  const {
    stepFormData: claimData,
    viewModal: claimView,
    selectedService: claimService,
  } = useSelector((state) => state.claim);

  const dose = watch("dose");
  const doseType = watch("doseType");
  const isPrescription =
    stepFormData?.prescription || claimData?.prescription || false;

  const isRequired = !!dose || !!doseType || isPrescription;

  useEffect(() => {
    if (selectedService?.dose || claimService?.dose) {
      setValue("dose", selectedService?.dose || claimService?.dose);
    }
    if (selectedService?.doseType || claimData?.doseType) {
      setValue("doseType", selectedService?.doseType || claimData?.doseType);
    }
  }, [selectedService, claimService, claimData, setValue]);

  return (
    <Col xs={12} sm={12} md={3}>
      <FalconComponentCard className="custom-card">
        <FalconComponentCard.Body className="custom-body">
          <Form.Group as={Row}>
            <Form.Label>
              Dose {isRequired && <span className="text-danger">*</span>}
            </Form.Label>

            {/* Dose input */}
            <Col xs={6} className="mb-2">
              <Controller
                name="dose"
                control={control}
                disabled={viewModal || claimView}
                rules={{
                  required: !!doseType || isPrescription,
                }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                    type="number"
                    min={0}
                    placeholder="Dose"
                    size="sm"
                  />
                )}
              />
            </Col>

            {/* Dose type select */}
            <Col xs={6}>
              <Controller
                name="doseType"
                control={control}
                disabled={viewModal || claimView}
                rules={{
                  required: !!dose || isPrescription,
                }}
                render={({ field }) => (
                  <Form.Select {...field} size="sm">
                    <option value="">Type</option>
                    {doseList.map((opt) => (
                      <option key={opt.ucumtype_code} value={opt.ucumtype_code}>
                        {opt.ucumtype_name}
                      </option>
                    ))}
                  </Form.Select>
                )}
              />
            </Col>
          </Form.Group>
        </FalconComponentCard.Body>
      </FalconComponentCard>
    </Col>
  );
};

export default DoseMedicalHistory;
